import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
import { Debug } from '@awayjs/core';
var TextExtent = /** @class */ (function (_super) {
    __extends(TextExtent, _super);
    function TextExtent(width, height, textFieldWidth, textFieldHeight, ascent, descent) {
        var _this = _super.call(this) || this;
        _this.width = +width;
        _this.height = +height;
        _this.textFieldWidth = +textFieldWidth;
        _this.textFieldHeight = +textFieldHeight;
        _this.ascent = +ascent;
        _this.descent = +descent;
        // @todo
        Debug.throwPIR('playerglobals/text/TextExtent', 'constructor', '');
        return _this;
    }
    return TextExtent;
}(ASObject));
export { TextExtent };
